/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header } from '@mairistem/composants';

/** Hauteur du bandeau, dont dépend le `calc(100% - 40px)` des panneaux. */
export const HAUTEUR_ENTETE_APERCU = 40;

interface EnteteApercuProps {
  titre?: string;
}

/**
 * Bandeau des panneaux d'aperçu.
 *
 * Reprend celui que `SectionCanva` rend lui-même, pour que tous les formats
 * partagent la même en-tête : le RTF s'affichait sans bandeau, seul panneau à
 * en être dépourvu.
 */
const EnteteApercu = (props: EnteteApercuProps) => {
  const { titre = 'APERÇU DU DOCUMENT' } = props;

  return (
    <Header
      as="h5"
      attached="top"
      block
      style={{
        backgroundColor: '#006594',
        color: 'white',
        height: HAUTEUR_ENTETE_APERCU,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
      }}
    >
      {titre}
    </Header>
  );
};

export default EnteteApercu;
